import createDappAsyncThunk from "../asyncThunk"
import { setCollectedProductIds } from "../slices/store"

export const orderProduct = createDappAsyncThunk(
  "store/orderProduct",
  async (
    { productId, price }: { productId: string; price: bigint },
    { extra: { sdk } },
  ) => {
    const order = await sdk.mezo.chain?.storeModule.collect(productId, price)

    return !!order
  },
)

export const getTahoClaimSignature = createDappAsyncThunk(
  "store/getTahoClaimSignature",
  async (
    { claimerId, address }: { claimerId: string; address: string },
    { extra: { sdk } },
  ) => {
    const claimSignature = await sdk.mezo.api.campaigns.getClaimData(
      claimerId,
      address,
    )

    return claimSignature
  },
)

export const claimTahoNFT = createDappAsyncThunk(
  "store/claimTahoNFT",
  async (
    { id, signature }: { id: string; signature: string },
    { extra: { sdk } },
  ) => {
    const claimed = await sdk.mezo.chain?.storeModule.claimTahoNFT(
      id,
      signature,
    )

    return !!claimed
  },
)

export const getCollectedProducts = createDappAsyncThunk(
  "store/getCollectedProducts",
  async (_, { dispatch, extra: { sdk } }) => {
    const collectedProducts = await sdk.mezo.chain?.storeModule.getOrders()

    if (collectedProducts && collectedProducts.length) {
      dispatch(
        setCollectedProductIds(
          collectedProducts.map((product) => product.productId),
        ),
      )
    }
  },
)
